import SwipeHint from "./SwipeHint";

function IntroView({ active }) {
  return (
    <div className="h-full w-screen flex flex-col">
      <div className="text-white flex flex-col items-center w-full h-[70%]">
        <div className="grow"></div>
        <span className="pxs-intro-text-small w-full text-center mb-1">
          Hi!
        </span>
        <span className="pxs-intro-text-large w-full text-center mb-1">
          I'm{" "}
          <span className="font-black text-red">
            <span className="pxs-intro-r-shadow">R</span>ohan
          </span>
          .
        </span>
        <span className="pxs-intro-text-small w-full text-center">
          I develop software.
        </span>
        <div className="grow"></div>
      </div>
      {active && <SwipeHint />}
    </div>
  );
}

export default IntroView;
